import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, Theme, SelectChangeEvent } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

interface Props {
	title: string;
	name: string;
	value?: string;
	options: { id: string; label: string; img?: string }[];
	variant?: 'outlined' | 'standard' | 'filled';
	handleSelectChange: (event: SelectChangeEvent) => void;
	styling?: {
		fullWidth?: boolean;
	};
	classes?: {
		menu: string;
	};
}

const DropDownWithLabel = (props: Props) => {
	const { title, name, value, variant, options, classes: styleClasses, styling } = props;
	const classes = useStyles(styling);
	return (
		<FormControl variant={variant} className={classes.select}>
			<InputLabel>{title}</InputLabel>
			<Select
				value={value}
				name={name}
				onChange={props.handleSelectChange}
				label={title}
				MenuProps={{
					className: styleClasses?.menu,
				}}
			>
				{options.map((option) => (
					<MenuItem key={option.id} value={option.id}>
						{option.img && <img className={classes.img} src={option.img} alt={option.label} />}
						{option.label}
					</MenuItem>
				))}
			</Select>
		</FormControl>
	);
};
const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		select: {
			margin: theme.spacing(2, 2, 2, 0),
			marginBottom: theme.spacing(2),
			minWidth: 150,
			width: (props: Props['styling']) => (props?.fullWidth ? '100%' : 'auto'),
		},
		img: {
			width: theme.spacing(2),
			marginRight: theme.spacing(2),
		},
	}),
);

export default DropDownWithLabel;
